import { required, maxLength } from 'vuelidate/lib/validators'
import { passesApiValidation } from '@/plugins/vuelidate/validators'

export const validations = {
  order: {
    purchase_order_number: {
      required,
      maxLength: maxLength(50),
      passesApiValidation: passesApiValidation('purchase_order_number')
    },
    needed_date: {
      required,
      passesApiValidation: passesApiValidation('needed_date')
    },
    billing_address_id: {
      required,
      passesApiValidation: passesApiValidation('billing_address_id')
    },
    shipping_address_id: {
      required,
      passesApiValidation: passesApiValidation('shipping_address_id')
    },
    orderItems: {
      required
    }
  }
}

export const messages = {
  order: {
    purchase_order_number: {
      required: 'This field is required',
      maxLength: 'This field can\'t be more than 50 characters long',
    },
    needed_date: {
      required: 'This field is required',
    },
    billing_address_id: {
      required: 'This field is required',
    },
    shipping_address_id: {
      required: 'This field is required',
    },
    orderItems: {
      required: 'Product requests must contain at least 1 item before saving',
    }
  }
}